import "../App.css";
import "../general.css";
import "../queries.css";
import mental_health from "../assets/images/mental_health.jpg";
import drink_responsibly from "../assets/images/drink_responsibly.webp";
import trash_surf from "../assets/images/trash_surf.jpg";


import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import Seo from "../components/SEO";
import { useFacebookPageView } from "../hook/useFacebookPageView";



function Health() {

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/health", title: "Don't fuck with your health page" });
  }, []);

  useFacebookPageView();

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [touchStart, setTouchStart] = useState(null);
  const [touchEnd, setTouchEnd] = useState(null);

  const minSwipeDistance = 50;

  const [carousel, setCarousel] = useState(0);

  const onTouchStart = (e: any) => {
    setTouchEnd(null);
    setTouchStart(e.targetTouches[0].clientX);
  };

  const onTouchMove = (e: any) => setTouchEnd(e.targetTouches[0].clientX);

  const onTouchEnd = () => {
    if (!touchStart || !touchEnd) return;
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > minSwipeDistance;
    const isRightSwipe = distance < -minSwipeDistance;
    isRightSwipe && setCarousel(carousel < 2 ? carousel + 1 : 0);
    isLeftSwipe && setCarousel(carousel > 0 ? carousel - 1 : 2);
    
  };

  useEffect(() => {
    console.log(windowWidth);
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
<section className="section-health"
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onTouchMove={onTouchMove}
        id="health"
      >
        <div className="container-mainsite">

          <div className="section-title">
            <h2 className="heading-secondary " >
              Don't fuck with your health!
            </h2>
          </div>
              <div className="carousel2" >
                
                <div
                  id="mh"
                  className={`${
                    carousel !== 0 && "hidden"
                  } carousel-card carousel-card--selected`}
                >
                  <div
                    className="carousel-image" 
                    style={{ display: windowWidth < 900 ? "none" : "flex"}}
                  >
                    <img
                      className="section-image2"
                      style={{ aspectRatio: "1142 / 1563"}}
                      src={mental_health}
                    />
                  </div>
                  <div className="carousel-box1">
                    <div className="heading-box">
                      <span className="subheading med-heading">
                        Maintaining your mental and physical health
                      </span>
                    </div>
                    <p className="text-box">
                      We aim to be more than just another beverage brand. <br />
                      <br />
                      Sexuality and intimate needs are not a marketing ploy. These
                      instincts are the oldest, most powerful, and most versatile
                      aspects of our heritage, which directly impact our physical
                      and mental well-being. Yet, they are often swept under the
                      rug. Too many unanswered questions. Too much fear. Too many
                      unspoken thoughts, and even more repression. Now is the moment
                      for us to engage in an open dialogue without any taboo.
                      <br />
                      <br />
                      Yes, these are intricate questions and should not be
                      simplified into easy answers. Each person's journey will be
                      individual, even if we walk some of its stages with others,
                      perhaps in pairs. Therefore, there are no universal,
                      one-size-fits-all solutions. Our own journey has demonstrated
                      that continuous self-improvement, self-learning, and
                      self-awareness can lead to a better mental and physical state
                      through discussion and personal experience. Our goal is to
                      offer support in this process.
                    </p>
                  </div>
                </div>
                <div
                  id="mh"
                  className={`${
                    carousel !== 1 && "hidden"
                  } carousel-card carousel-card--selected`}
                >
                  <div
                    className="carousel-image"
                    style={{ display: windowWidth < 900 ? "none" : "flex"}}
                  >
                    <img
                      className="section-image2"
                      style={{ aspectRatio: "1142 / 1563"}}
                      src={drink_responsibly}
                    />
                  </div>
                  <div className="carousel-box1">
                    <div className="heading-box">
                      <span className="subheading med-heading">
                        Drink Responsibly
                      </span>
                    </div>
                    <p className="text-box">
                      You can have too much of a good thing. Drink with
                      responsibility. Two is the recommended daily intake and please
                      don't drink more than four a day.
                      <br /> <br />
                      Do not consume with the following medicines: blood thinners,
                      antidepressants, chemotherapy drugs, and bronchodilators
                      <br /> <br />
                      Not recommended during pregnancy and/or for people under 18.
                    </p>
                  </div>
                </div>

                <div
                  id="mh"
                  className={`${
                    carousel !== 2 && "hidden"
                  } carousel-card carousel-card--selected mental-health`}
                >
                  <div
                    className="carousel-image"
                    style={{ display: windowWidth < 900 ? "none" : "flex", aspectRatio: "1 / 1" }}
                  >
                    <img
                      className="section-image2"
                      style={{ aspectRatio: "1142 / 1563"}}
                      src={trash_surf}
                    />
                  </div>
                  <div className="carousel-box1">
                    <div className="heading-box">
                      <span className="subheading med-heading">
                        No Plastics Policy
                      </span>
                    </div>
                    <p className="text-box">
                      Plastics? Not in our playbook. <br />
                      <br />
                      We take this F***ing serious. During a period of job-hopping, our founder joined forces with a plastic waste recycling company. The 3 months he spent there were enough to make him hate and avoid plastic for life. 
                      <br /> <br />
                      Speaking of which, let's talk about those potions we call ’plastic bottles’. They’re swimming pools for microplastic compared to plain ol' tap water. It's like they're hosting a never-ending party for tiny polymer buddies. And if that wasn't enough, these plastic shindigs can also leak out super toxic stuff as they decompose.
                      <br /> <br />
                      Plastic recycling?
                      <br />
                      Oh, please! Right now, it's like trying to turn a rubber duck into solid gold. The tech's got a long way to waddle before it can swim.
                    </p>
                  </div>
                </div>

              </div>
            
        </div>
        <div
              className="carousel_nav"
              style={{  zIndex: 566, position:"relative", bottom: "3.6rem", }}
            >
                    <span
                      onClick={() => setCarousel(0)}
                      className={`carousel_btn ${
                        carousel === 0 && "carousel_btn--selected"
                      }`}
                    ></span>
                    <span
                      onClick={() => setCarousel(1)}
                      className={`carousel_btn ${
                        carousel === 1 && "carousel_btn--selected"
                      }`}
                    ></span>
                    <span
                      onClick={() => setCarousel(2)}
                      className={`carousel_btn ${
                        carousel === 2 && "carousel_btn--selected"
                      }`}
                    ></span>
          </div>
      </section>
    </motion.main>
  );
}

export default Health;
